module.exports = __webpack_public_path__ + "/login_ui/img/cz-13fa5f4dbb790816f63687a6b7e92cc9.svg";